/**
 * Машина из чужого города.
 *
 * Сток менеджер видит только по своим городам, но поиск по полному VIN
 * показывает машину откуда угодно — иначе её не перенести к себе. Раз машина
 * нашлась, менеджер по привычке считает её своей, поэтому город у таких машин
 * помечаем (24.10.2026, просьба перенести машину в Тараз).
 *
 * Города приходят в профиле (`user.cities`) списком вида [{ cityId }].
 * Пустой список — у сотрудника нет ограничения по городам (например, админ):
 * тогда чужих машин для него не бывает.
 */
export function isForeignCityCar(carCityId, userCities) {
  if (!carCityId) return false;
  if (!Array.isArray(userCities) || userCities.length === 0) return false;

  return !userCities.some((item) => Number(item?.cityId ?? item?.id ?? item) === Number(carCityId));
}

export default isForeignCityCar;
